<script setup>
import { Offcanvas } from 'bootstrap';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import { useDataFormat } from '@/composables/useDataFormat.js';
import { aanvragerStore } from '@/stores/aanvrager.js';
import { formStore } from '@/stores/form.js';

const aanvrager = aanvragerStore();

const { geslacht, voorletters, tussenvoegsels, achternaam, emailadres } = storeToRefs(aanvrager);

const form = formStore();
const handleSubmit = () => {
  form.saveSessionForLater();
  let myOffcanvas = document.getElementById('saveForLater');
  let bsOffcanvas = Offcanvas.getInstance(myOffcanvas);
  bsOffcanvas.hide();
};

const { addDotAfterEachLetter, removeDots } = useDataFormat();

const voorlettersComputed = computed({
  get() {
    return addDotAfterEachLetter(voorletters.value);
  },
  set(val) {
    voorletters.value = removeDots(val);
  },
});
</script>

<template>
  <BaseOffCanvas
    target="saveForLater"
    :title="$t('general.saveForLater.title')"
  >
    <FormKit
      type="form"
      :actions="false"
      autocomplete="off"
      @submit="handleSubmit"
    >
      <div class="row">
        <div class="col">
          <p>{{ $t('general.saveForLater.body') }}</p>
        </div>
      </div>
      <!-- Salutation -->
      <div class="row">
        <div class="col">
          <BaseMultiRadio
            v-model="geslacht"
            name="applicantsalutation"
            :label="$t('almost-insured.naw.salutation.title')"
            :options="$tm('almost-insured.naw.salutation.option')"
            validation="required"
          />
        </div>
      </div>

      <!-- Initials -->
      <div class="row">
        <div class="col">
          <BaseInput
            v-model="voorlettersComputed"
            name="applicantInitials"
            :label="$t('almost-insured.naw.initials')"
            :placeholder="$t('almost-insured.naw.initialsPlaceholder')"
            :validation="'required|initialsCorrect'"
            maxlength="10"
          />
        </div>
      </div>

      <!-- Prefix -->
      <div class="row">
        <div class="col">
          <BaseInput
            v-model="tussenvoegsels"
            name="applicantPrefix"
            :label="$t('almost-insured.naw.prefix')"
            :placeholder="$t('almost-insured.naw.prefixPlaceholder')"
            validation="alpha_spaces:latin"
            maxlength="10"
            uppercase
          />
        </div>
      </div>

      <!-- Lastname -->
      <div class="row">
        <div class="col">
          <BaseInput
            v-model="achternaam"
            name="applicantLastname"
            :label="$t('almost-insured.naw.lastName')"
            :placeholder="$t('almost-insured.naw.lastNamePlaceholder')"
            validation="required"
            minlength="2"
            maxlength="50"
          />
        </div>
      </div>

      <!-- Email -->
      <div class="row">
        <div class="col">
          <BaseInput
            v-model="emailadres"
            name="applicantEmail"
            :label="$t('almost-insured.naw.email')"
            :placeholder="$t('almost-insured.naw.emailPlaceholder')"
            :validation="'required|email|isEmailCorrect'"
            minlength="2"
            maxlength="50"
            inputmode="email"
          />
        </div>
      </div>

      <div class="row">
        <div class="col">
          <BaseButton type="submit">
            {{ $t('general.saveForLater.CTA') }}
          </BaseButton>
        </div>
      </div>
    </FormKit>
  </BaseOffCanvas>
</template>
